import { asyncApi } from "@/services/apiService";

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/lookup`;

export default {
  availableEvent: async (onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/trip-log/available-event`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  chauffeurCommon: async (onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/rental-type/chauffeur`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  selfdriveCommon: async (onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/rental-type/self-drive`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  supportedCurrencies: async (onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/supported-currencies`,
      onBeginCallback,
      onFinallyCallback
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/shop/lookup/lookupService.js